import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FindNewContactGetDto } from 'crono-fe-common/types/findNew';
import { Response } from 'crono-fe-common/types/response';
import { findNewPaths } from 'crono-fe-common/utils/findNew/requests';
import client from 'utils/clients/client';
import {
  findNewQueryCacheOptions,
  findNewQueryKeys,
  parseFindNewData,
} from './findNewRequest';

export default function useFindNewContactLookup() {
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);

  const call = useCallback(
    async (params: {
      publicId: string;
      withOtherFields?: boolean;
    }): Promise<FindNewContactGetDto | null> => {
      const withOtherFields = params.withOtherFields ?? true;
      setIsLoading(true);
      try {
        const response = await queryClient.fetchQuery<
          Response<FindNewContactGetDto>
        >({
          queryKey: findNewQueryKeys.contact(params.publicId, withOtherFields),
          queryFn: () =>
            client({
              url: findNewPaths.contact(params.publicId, { withOtherFields }),
              config: { method: 'get' },
            }),
          ...findNewQueryCacheOptions,
        });
        return parseFindNewData(response?.data);
      } catch {
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [queryClient],
  );

  return { call, isLoading };
}
